<app-welcome *ngIf="!($organization | async)?.welcome_dismissed; else dashbaord"></app-welcome>
<ng-template #dashbaord>
	<app-page-header title="Dashboard" [back]="false"></app-page-header>
	<div>
		<div class="mb-8">
			<div class="grid grid-cols-6 py-4 gap-2">
				<div class="rounded-lg p-2 bg-slate-100 h-20">
					<div class="text-sm">Properties</div>
					<div class="text-2xl font-bold">{{ ($organization | async)?.statistics?.properties?.total }}</div>
				</div>
				<!-- <div class="rounded-lg p-2 bg-slate-100 h-20">
					<div class="text-sm">Managers / Installers</div>
					<div class="text-2xl font-bold"></div>
				</div>
				<div class="rounded-lg p-2 bg-slate-100 h-20">
					<div class="text-sm">Users</div>
					<div class="text-2xl font-bold"></div>
				</div> -->
			</div>
			<div class="before:border-t before:border-secondary before:content-[''] before:absolute before:w-full before:left-0"></div>
		</div>
		<div class="flex gap-8 mb-4">
			<div class="">
				<app-dashbaord-doughnut-chart [data]="$locationsData | async" text="Locations online"></app-dashbaord-doughnut-chart>
			</div>
			<div class="">
				<app-dashbaord-doughnut-chart [data]="$hubsData | async" text="Hubs online"></app-dashbaord-doughnut-chart>
			</div>
			<div class="">
				<app-dashbaord-doughnut-chart [data]="$devicesData | async" text="Devices online"></app-dashbaord-doughnut-chart>
			</div>
			<!-- <div class="">
				<app-dashbaord-doughnut-chart text="Devices Batteries"></app-dashbaord-doughnut-chart>
			</div>
			<div class="">
				<app-dashbaord-doughnut-chart text="Water Leak Sensors"></app-dashbaord-doughnut-chart>
			</div>
			<div class="">
				<app-dashbaord-doughnut-chart text="Smoke Sensors"></app-dashbaord-doughnut-chart>
			</div> -->
		</div>
		<!-- <div>
			<div class="before:border-t before:border-secondary before:content-[''] before:absolute before:w-full before:left-0"></div>
			<div class="grid grid-cols-6 py-4 gap-2">
				<div class="rounded-lg p-2 bg-orange-100 h-20">
					<div class="text-sm">Temperature Alerts</div>
					<div class="text-2xl font-bold">0</div>
				</div>
				<div class="rounded-lg p-2 bg-blue-100 h-20">
					<div class="text-sm">Humidity Alerts</div>
					<div class="text-2xl font-bold">0</div>
				</div>
				<div class="rounded-lg p-2 bg-green-100 h-20">
					<div class="text-sm">Air Quality Alerts</div>
					<div class="text-2xl font-bold">2</div>
				</div>
				<div class="rounded-lg p-2 bg-red-100 h-20">
					<div class="text-sm">Intrusion alerts</div>
					<div class="text-2xl font-bold">2</div>
				</div>
				<div class="rounded-lg p-2 bg-slate-100 h-20">
					<div class="text-sm">Weather Alerts</div>
					<div class="text-2xl font-bold">7</div>
				</div>
			</div>
			<div class="before:border-t before:border-secondary before:content-[''] before:absolute before:w-full before:left-0"></div>
		</div> -->
		<!-- <div class="my-4">
		<app-dashbaord-energy-chart></app-dashbaord-energy-chart>
	</div> -->
		<!--<div class="my-4">
		<h1>Gateway events</h1>
		<div class="flex items-center justify-between pb-4">
			<div></div>
			<div>
				<label for="table-search" class="sr-only">Search</label>
				<span class="p-input-icon-left relative">
					<i
						class="inline-block leading-none absolute -mt-[0.5rem] top-1/2"
					>
						<fa-icon
							class="inline-block leading-none"
							[icon]="['fas', 'magnifying-glass']"
						></fa-icon>
					</i>
					<input
						pInputText
						id="table-search"
						type="search"
						[(ngModel)]="term"
						(keyup)="onSearchEvent()"
					/>
				</span>
			</div>
		</div>

		 <div class="mb-4 flex items-center gap-2">
			<p-button (onClick)="reloadGatewaysEvents()" [text]="true">
				<fa-icon [icon]="['fas', 'rotate-right']"></fa-icon>
				<span class="ml-2 sr-only">Reload gateways events</span>
			</p-button>
			<div class="ml-auto">
				<p-paginator
					(onPageChange)="onPageChange($event)"
					[first]="first"
					[rows]="($filter | async)?.per_page"
					[totalRecords]="($filter | async)?.total"
					[rowsPerPageOptions]="rowsPerPageOptions"
					[showCurrentPageReport]="true"
					currentPageReportTemplate="{first} - {last} of {totalRecords}"
				></p-paginator>
			</div>
		</div>
		<p-table
			#table
			[value]="$gatewaysEventsTableData | async"
			(onLazyLoad)="sortChanged($event)"
			[customSort]="true"
			sortMode="single"
			[lazy]="true"
			[lazyLoadOnInit]="false"
			[loading]="$loading | async"
		>
			<ng-template pTemplate="loadingicon">
				<fa-icon
					[icon]="['fas', 'spinner']"
					[animation]="'spin'"
				></fa-icon>
			</ng-template>
			<ng-template pTemplate="reorderindicatorupicon">
				<fa-icon
					[icon]="['fas', 'spinner']"
					[animation]="'spin'"
				></fa-icon>
			</ng-template>
			<ng-template pTemplate="reorderindicatordownicon">
				<fa-icon
					[icon]="['fas', 'spinner']"
					[animation]="'spin'"
				></fa-icon>
			</ng-template>
			<ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
				<fa-icon
					[icon]="['fas', 'sort']"
					*ngIf="sortOrder === 0"
				></fa-icon>
				<fa-icon
					[icon]="['fas', 'sort-up']"
					*ngIf="sortOrder === 1"
				></fa-icon>
				<fa-icon
					[icon]="['fas', 'sort-down']"
					*ngIf="sortOrder === -1"
				></fa-icon>
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="gateway">
						Gateway <p-sortIcon field="gateway"></p-sortIcon>
					</th>
					<th pSortableColumn="device">
						Device <p-sortIcon field="device"></p-sortIcon>
					</th>
					<th pSortableColumn="old_value">
						Old value <p-sortIcon field="old_value"></p-sortIcon>
					</th>
					<th pSortableColumn="new_value">
						New value <p-sortIcon field="new_value"></p-sortIcon>
					</th>
					<th pSortableColumn="type">
						Type <p-sortIcon field="type"></p-sortIcon>
					</th>
					<th pSortableColumn="created_at">
						Created at <p-sortIcon field="created_at"></p-sortIcon>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="loadingbody">
				<tr
					*ngFor="
						let item of [].constructor(($filter | async)?.per_page)
					"
				>
					<td *ngFor="let col of columns">
						<p-skeleton></p-skeleton>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-event>
				<tr *ngIf="!($loading | async)">
					<td>
						<a
							[routerLink]="['/gateways', event.id]"
							pButton
							class="p-button-text"
						>
							{{ event.gateway }}
						</a>
					</td>
					<td>{{ event.device }}</td>
					<td>{{ event.old_value }}</td>
					<td>{{ event.new_value }}</td>
					<td>{{ event.type }}</td>
					<td>
						{{
							event.created_at == "-"
								? event.created_at
								: (event.created_at
								  | date : "EEE, MMM d, y, h:mm:ss a")
						}}
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="6">
						<div
							class="flex flex-col p-3 mb-5 justify-center items-center"
						>
							<fa-icon
								class="text-[64px] mb-2 opacity-20"
								[icon]="['fas', 'file-circle-exclamation']"
							></fa-icon>
							<h1 class="font-semibold text-lg">
								No Gateways events yet
							</h1>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>-->
	</div>
</ng-template>
